import $ from '@vaersaagod/tools/Dom';

export default el => {
    const dom = $(el);
    const button = dom.find('[data-button]');
    const progress = dom.find('[data-progress]').get(0);
    const current = dom.find('[data-current]');
    const audioElement = dom.find('[data-audio]');
    const audio = audioElement.get(0);

    let updateId = 0;
    let playedPercent = 0;


    const update = () => {
        const formattedTime = new Date(audio.currentTime * 1000).toISOString().substr(14, 5);
        current.text(formattedTime);
        playedPercent = audio.currentTime / audio.duration;
        TweenLite.to(progress, 0.1, { scaleX: playedPercent, ease: Linear.easeNone });
    };

    const stopUpdateInterval = () => {
        clearInterval(updateId);
    };

    const startUpdateInterval = () => {
        stopUpdateInterval();
        updateId = setInterval(update, 90);
    };

    const play = () => {
        audio.play();
    };

    const onPlay = () => {
        startUpdateInterval();
        dom.addClass('playing');
    };

    const pause = () => {
        audio.pause();
    };

    const onPause = () => {
        stopUpdateInterval();
        dom.removeClass('playing');
    };

    const onComplete = () => {
        stopUpdateInterval();
        dom.removeClass('playing');
        playedPercent = 0;
        TweenLite.to(progress, 1.5, { scaleX: 0, ease: Circ.easeInOut });
    };

    const toggle = () => {
        if (dom.hasClass('playing')) {
            pause();
            button.attr('aria-label', 'Play');
        } else {
            play();
            button.attr('aria-label', 'Pause');
        }
    };

    const init = () => {
        button.on('click', toggle);
        audioElement.on('playing', onPlay);
        audioElement.on('pause', onPause);
        audioElement.on('ended', onComplete);
    };

    const destroy = () => {
        stopUpdateInterval();
        button.off('click');
        audioElement.off('playing', onPlay);
        audioElement.off('pause', onPause);
        audioElement.off('ended', onComplete);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/AudioPlayer.js